module.exports = __webpack_public_path__ + "static/media/machine-handler.565b2d57.png";